import { useTheme } from "@zero/hooks";
import { ThemeMode } from "@zero/types/enum";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle() {
  const { mode, toggleMode } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleMode}
      className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-secondary text-secondary-foreground hover:bg-secondary/80 transition-colors"
      aria-label="Toggle theme"
    >
      {mode === ThemeMode.Dark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
